import { render, staticRenderFns } from "./jsEditor.vue?vue&type=template&id=fcba5086&scoped=true&"
import script from "./jsEditor.vue?vue&type=script&lang=js&"
export * from "./jsEditor.vue?vue&type=script&lang=js&"
import style0 from "./jsEditor.vue?vue&type=style&index=0&id=fcba5086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba5086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
